module.exports = __webpack_public_path__ + "static/media/Wind.66c6c8df.mp3";